import React, { ErrorInfo, useEffect, useState } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import CommonModal from "../modal/CommonModal";

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        // Automatically close after a while if you prefer
        const timer = setTimeout(() => {
            setVisible(false);
            resetErrorBoundary();
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    if (!visible) return null;

    return (
        <CommonModal
            show={visible}
            onHide={() => { setVisible(false); resetErrorBoundary(); }}
            title="Error"
            size="md"
            showFooter={false}
        >
            <div
                style={{
                    height: "50vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                }}
            >
                <h1>Something went wrong 😢</h1>
                <p>{error.message}</p>
                <button
                    onClick={() => {
                        setVisible(false);
                        resetErrorBoundary();
                    }}
                    style={{
                        marginTop: "1rem",
                        padding: "10px 20px",
                        backgroundColor: "#dc3545",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Try Again
                </button>
            </div>
        </CommonModal>
    );
}

interface GlobalErrorBoundaryProps {
    children: React.ReactNode;
}

const GlobalErrorBoundary: React.FC<GlobalErrorBoundaryProps> = ({ children }) => {
    // Called when an error occurs
    const handleError = (error: Error, info: ErrorInfo) => {
        console.error("Global Error Boundary caught an error:", error, info);

        // Handle specific chunk loading errors
        if (error.message.includes("ChunkLoadError")) {
            console.warn("ChunkLoadError detected — reloading app...");
            window.location.reload();
        }

        // Optional: send to your server
        // fetch("/api/log-error", { method: "POST", body: JSON.stringify({ error, info }) });
    };

    const handleReset = () => {
        // Optional: reset app state or refresh
        //window.location.reload();
    };

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={handleError}
            onReset={handleReset}
        >
            {children}
        </ErrorBoundary>
    );
};

export default GlobalErrorBoundary;
